import { render, staticRenderFns } from "./inscription-list-page.vue?vue&type=template&id=8db68bd4&"
import script from "./inscription-list-page.vue?vue&type=script&lang=js&"
export * from "./inscription-list-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports